import { useEffect } from 'react'
import { Intercom } from '@helpers'
import { Classroom as ClassroomConstants } from '@constants'

export const useHideIntercomLauncher = (step) => {
  useEffect(() => {
    if (step !== ClassroomConstants.STEPS.READY) return
    Intercom.hideLauncher()
    Intercom.update()
  }, [step])
}
